import React, { Component } from 'react';
import {
  Grid, Row, Col, Image,
} from 'react-bootstrap';
import { Link } from 'react-router';

/** CUSTOM COMPONENTS **/
export class BoxProductsContent extends Component{
  render(){
    return (
      <Col xs={12} md={12} className={'boxProductsContent text-center'}>
        <Col xs={12} md={12}>
          <h2>Lavagens, como <span className={'bgWord'}> <i>suas roupas</i></span> nunca viram.</h2>
          <p>A Tchau Varal possui alta tecnologia para tratar as peças mais delicadas, oferecendo sempre o melhor serviço, com ótimos resultados em remoção de manchas e excelente passadoria, além de higienizar suas roupas e utensílios domésticos ou empresariais com competência e qualidade no atendimento.</p>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/camisetas.png'} responsive />
            <p>Camisetas, Calça jeans, Bermudas, Shorts, etc.</p>
          </Col>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/ternos.png'} responsive />
            <p>Ternos, Tailleurs, Camisas, Blaisers, etc.</p>
          </Col>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/almofadas.png'} responsive />
            <p>Edredons, Cobertores, Lençóis, Toalhas, Cortinas, Almofadas, etc.</p>
          </Col>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/roupas_de_criancas.png'} responsive />
            <p>Roupas de crianças em geral, do casual à festas, etc.</p>
          </Col>

          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/vestidos_de_festa.png'} responsive />
            <p>Vestidos de festa, Smoking, Becas, Casacos, etc.</p>
          </Col>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/restaurantes.png'} responsive />
            <p>Restaurantes, buffets, clubes, clínicas, pousadas, indústrias, confecções, etc.</p>
          </Col>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/tapetes_bichos_de_pelucia.png'} responsive />
            <p>Tapetes, Roupas de couro, Bichos de pelúcia, Tênis e Sapatos.</p>
          </Col>
          <Col xs={12} md={3} className={'no-padding item'}>
            <Image src={'assets/images/tingimento.png'} responsive />
            <p>Tingimento de roupas novas e usadas.</p>
          </Col>
        </Col>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Site/BoxProductsContent/BoxProductsContent.js